<template>
	<div class="customer">
		<div class="customer-top">
			<img src="@/assets/HomeView/Bitmap.png" style="width: 72px; height: 72px" />
		</div>
		<div class="customer-home" style="display: flex;">
			<div style="margin-top: 3px; margin-right: 3px;">
				<img src="@/assets/Home_slices1/Vector@2x(3).png" style="width: 16px; height: 16px" />
			</div>
			<div>
				客服热线
			</div>
		</div>
		<div class="customer-phone">400-696-5550</div>
		<div class="border-top"></div>
		<div style="display: flex; align-items: center" class="theTop" @click="AbortSignalClick">
			<img src="@/assets/Home_slices1/Vector@2x(2).png" style="width: 16px; height: 16px" />
			<div class="title-right">置顶</div>
		</div>
	</div>
</template>

<script setup>
const AbortSignalClick = () => {
	 window.scrollTo(0, 0);
};
</script>

<style lang="scss" scoped>
.customer {
	width: 120px;
	height: 191px;
	background: #ffffff;
	border-radius: 8px 8px 8px 8px;
	position: fixed;
	z-index: 100;
	z-index: 4;
	top: 52%;
	right: 20px;
	display: flex;
	flex-direction: column;
	align-items: center;
	box-shadow: 0px 4px 4px 0px rgba(0,0,0,0.09);
}

.customer-top {
	margin-top: 12px;
}
.customer-home {
	font-family: PingFang SC, PingFang SC;
	font-weight: 400;
	font-size: 16px;
	margin-top: 4px;
	color: #333333;
	font-style: normal;
	text-transform: none;
}
.customer-phone {
	font-family: PingFang SC, PingFang SC;
	font-weight: 600;
	font-size: 14px;
	color: #ff0000;
	font-style: normal;
	text-transform: none;
	margin-top: 2px;
}
.border-top {
	width: 85px;
	height: 0px;
	border-top: 1px solid #eeeeee;
	padding-top: 12px;
	margin-top: 12px;
}
.title-right {
	font-family: PingFang SC, PingFang SC;
	font-weight: 400;
	font-size: 14px;
	color: #333333;
	text-align: center;
	font-style: normal;
	text-transform: none;
	margin-left: 6px;
}

.theTop{
	cursor: pointer;
}
</style>
